module.exports = __webpack_public_path__ + "img/15_newYouth_lxh.bf2ef47a.png";